import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../../global/globals';

export interface ModuleType {
  id?: number;
  name: string;
  code: string;
}

@Injectable({ providedIn: 'root' })
export class ModuleTypeService {
  private baseUrl: string;

  constructor(private http: HttpClient, private globals: Globals) {
    this.baseUrl = this.globals.backendUri + '/module-type';
  }

  getAll(): Observable<ModuleType[]> {
    return this.http.get<ModuleType[]>(this.baseUrl);
  }

  getById(id: number): Observable<ModuleType> {
    return this.http.get<ModuleType>(`${this.baseUrl}/${id}`);
  }

  create(moduleType: ModuleType): Observable<ModuleType> {
    return this.http.post<ModuleType>(this.baseUrl, moduleType);
  }

  update(id: number, moduleType: ModuleType): Observable<ModuleType> {
    return this.http.put<ModuleType>(`${this.baseUrl}/${id}`, moduleType);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
